export default {"src":"/_next/static/media/female_2.0e608540.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};